import "./inputStly.css";

const InputField = ({ placeholder, setValue, value, type, newStyle, id = "", maxChar = 100 }) => {
  let style = JSON.parse(newStyle);

  return (
    <>
      <div className='inputDivWr' style={style}>
        <input id={id} className='inputField' value={value} type={type} onChange={(e) => setValue(e.target.value)} required={true} maxLength={maxChar} />
        <p className='inputLable'>{placeholder}</p>
      </div>
    </>
  );
};

export default InputField;
